<div
  id="container"
  [ngClass]="{
    'top-item': isFirstItem,
    'bottom-item': isLastItem,
    selected: selected,
    noHoverCursor: hideSelectButton
  }"
>
  <div
    class="main-information-wrapper"
    [ngClass]="{ 'flex-center': !!textOverTitle }"
  >
    <div class="button-container" *ngIf="!hideSelectButton">
      <zaver-radio-button
        [selected]="selected"
        [selectedColor]="color"
      ></zaver-radio-button>
    </div>

    <div class="text-container">
      <span class="textOverTitle" *ngIf="!!textOverTitle">{{
        textOverTitle
      }}</span>
      <div class="title">
        {{ title }}
      </div>
      <div class="description" *ngIf="!!description">
        {{ description }}
      </div>
    </div>

    <div class="img-container" *ngIf="!!imgSrc">
      <zaver-badge *ngIf="!!imgSrc" imgSrc="{{ imgSrc }}" color="{{ color }}">
      </zaver-badge>
    </div>
    <div class="icon-container">
      <app-zaver-icon
        *ngIf="zaverIcon"
        [name]="zaverIcon.name"
        [size]="zaverIcon.size"
        [override]="zaverIcon.override">
      </app-zaver-icon>
  </div>
  </div>

  <div class="bullet-points-wrapper" *ngIf="selected && !hideBulletPoints">
    <div class="bullet" *ngFor="let bullet of bulletPoints">
      <app-zaver-icon name="checkmark" [size]="12"></app-zaver-icon>
      <p>{{ bullet }}</p>
    </div>
  </div>

  <a
    *ngIf="showTermsLink && selected"
    class="show-terms-link"
    (click)="emitTermsClick()"
  >
    {{ linkText }}
  </a>
</div>
